import {
  BrowserCacheLocation,
  Configuration, PublicClientApplication,
  RedirectRequest
} from '@azure/msal-browser';
import * as microsoftTeams from '@microsoft/teams-js';
import { TeamsLoginEndPath } from 'utils/routes';
import { isProxied, proxyPrefix } from '../utils/proxy';

// TODO: change redirectUri: isProxied()
// ? window.location.origin + proxyPrefix
// : window.location.origin,
// to redirectUri: window.location.origin,
// when proxying from (dev.|qa.|stage.)mytech.ge.com/portal is no longer needed

export const azureLoginRequest = {
  scopes: ["User.Read"]
};

const configuration: Configuration = {
  auth: {
    redirectUri: isProxied()
      ? window.location.origin + proxyPrefix
      : window.location.origin,
    authority: '',
    clientId: '',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    // TODO: only store auth state in cookie if there are compatibility issues
    // with IE
    storeAuthStateInCookie: false,
  },
};

export let loginRequestConfig: RedirectRequest;

// TODO: Expose the instance as a function that creates an instance (or returns the initialized instance if already created)
export let msalInstance: PublicClientApplication;
export let msalTeamsConfig: Configuration;

export const initMsalInstance = (config: any) => {
  configuration.auth = {
    redirectUri: configuration.auth.redirectUri,
    authority: config.authority,
    clientId: config.clientId
  }
  msalInstance = new PublicClientApplication(configuration);
  const scope = config.clientId + '/.default';
  loginRequestConfig = { scopes: [scope] };

  msalTeamsConfig = {
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
  };
}

export const getRequestConfigInTeams = (context: microsoftTeams.app.Context): RedirectRequest => {
  return {
    ...loginRequestConfig,
    redirectUri: window.location.origin + TeamsLoginEndPath,
    loginHint: context.user?.loginHint,
  };
};

// Helpful Azure AD authentication references
/*
- MSAL Browser docs (helpful for understanding various components exposed by the library) - https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-browser/docs
- Auth workflow                                                                           - https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-auth-code-flow
- Basic auth tutorial                                                                     - https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-javascript-auth-code
- Setting up a new App Registration                                                       - https://docs.microsoft.com/en-us/azure/active-directory/develop/quickstart-register-app
- Reply URL info                                                                          - https://docs.microsoft.com/en-us/azure/active-directory/develop/reply-url
*/

